import { clubAt } from './clubs.mock';
import type { Fixture, FixtureTeam } from '@/types';

const NORTH = clubAt(0);
const HARBOUR = clubAt(1);

/** Shaped exactly like the API, so screens behave the same either way. */

const UNITED: FixtureTeam = { teamId: NORTH.teamId, name: NORTH.name, shortCode: NORTH.shortCode };
const CITY: FixtureTeam = { teamId: HARBOUR.teamId, name: HARBOUR.name, shortCode: HARBOUR.shortCode };

const hoursFromNow = (hours: number): string =>
  new Date(Date.now() + hours * 60 * 60 * 1000).toISOString();

const base = { seriesId: 900001, leagueId: 900001 };

export const MOCK_FIXTURES: readonly Fixture[] = [
  {
    ...base,
    fixtureId: 900001,
    homeTeamId: UNITED.teamId,
    awayTeamId: CITY.teamId,
    home: UNITED,
    away: CITY,
    name: `${UNITED.name} vs ${CITY.name} (GW1)`,
    startingAt: hoursFromNow(-72),
    stateName: 'FT',
    homeScore: 2,
    awayScore: 1,
    venueName: NORTH.venue,
  },
  {
    ...base,
    fixtureId: 900002,
    homeTeamId: CITY.teamId,
    awayTeamId: UNITED.teamId,
    home: CITY,
    away: UNITED,
    name: `${CITY.name} vs ${UNITED.name} (GW1 return)`,
    startingAt: hoursFromNow(-48),
    stateName: 'FT',
    homeScore: 1,
    awayScore: 1,
    venueName: HARBOUR.venue,
  },
  {
    ...base,
    fixtureId: 900003,
    homeTeamId: UNITED.teamId,
    awayTeamId: CITY.teamId,
    home: UNITED,
    away: CITY,
    name: `${UNITED.name} vs ${CITY.name} (in play)`,
    startingAt: hoursFromNow(-1),
    // Deliberately live, so the in-play state is exercised in the demo.
    stateName: 'INPLAY_2ND_HALF',
    homeScore: 2,
    awayScore: 1,
    venueName: NORTH.venue,
  },
  {
    ...base,
    fixtureId: 900004,
    homeTeamId: CITY.teamId,
    awayTeamId: UNITED.teamId,
    home: CITY,
    away: UNITED,
    name: `${CITY.name} vs ${UNITED.name} (GW3)`,
    startingAt: hoursFromNow(52),
    stateName: 'NS',
    venueName: HARBOUR.venue,
  },
  {
    ...base,
    fixtureId: 900005,
    homeTeamId: UNITED.teamId,
    awayTeamId: CITY.teamId,
    home: UNITED,
    away: CITY,
    name: `${UNITED.name} vs ${CITY.name} (GW4)`,
    startingAt: hoursFromNow(100),
    stateName: 'NS',
    venueName: NORTH.venue,
  },
];
